define('home/views/ForumProfileCardCollectionView',[
    'home/views/common/FetchableCollectionView',
    'home/views/ForumProfileCardRecentView',

    'home/mixins/withViewFeedTracking',
], function (
    FetchableCollectionView,
    ForumProfileCardRecentView,

    withViewFeedTracking
) {
    'use strict';

    var ForumProfileCardCollectionView = FetchableCollectionView.extend({
        className: 'cards',

        itemView: ForumProfileCardRecentView,
    });

    withViewFeedTracking.call(ForumProfileCardCollectionView.prototype);

    return ForumProfileCardCollectionView;
});

